import classNames from "classnames";
import React from "react";
import { actions, Control } from "react-redux-form";

import { RadioButton } from "../../../../core/atoms/rrf";
import { EnquiryFormSection } from "./common";

import "./recommendedBy.scss";

interface OwnProps {
  dispatch: any;
}

export class RecommendedBy extends EnquiryFormSection<OwnProps> {
  private resetOtherAndPressSource() {
    this.props.dispatch(actions.reset(`${this.props.model}.otherPressSource`));
    this.props.dispatch(actions.reset(`${this.props.model}.otherSource`));
    this.props.dispatch(actions.reset(`${this.props.model}.pressSource`));
  }

  protected shouldUpdateValidity(oldProps, newProps) {
    return false;
  }

  protected syncValidity(formState: Forms.EnquiryForm) {
    // NOOP - this field is always valid
  }

  public render() {
    const { model, className, id, formState } = this.props;
    const recommendedBy = formState.recommendedBy || {} as any;

    return (
      <section id={id} className={classNames("recommended-by", className)}>
        <header>
          <h2>Where did you hear about TravelLocal?</h2>
          <p>This is optional, but it's really helpful for us to know.</p>
        </header>
        <div className="enquiry-form-question enquiry-form-radio-select">
          <RadioButton
            model={`${model}.source`}
            id="travelled-before"
            value="travelled with travellocal before"
            label="Travelled with TravelLocal before"
            onCheckedChange={isChecked => isChecked && this.resetOtherAndPressSource()}
          />
          <RadioButton
            model={`${model}.source`}
            id="recommended-by-search"
            value="search engine"
            label="Search engine"
            onCheckedChange={isChecked => isChecked && this.resetOtherAndPressSource()}
          />
          <RadioButton
            model={`${model}.source`}
            id="television-ad"
            value="television"
            label="Television"
            onCheckedChange={isChecked => isChecked && this.resetOtherAndPressSource()}
          />
          <RadioButton
            model={`${model}.source`}
            id="recommended-by-press-media"
            value="press / media"
            label="Press / media"
            onCheckedChange={isChecked => isChecked && this.resetOtherAndPressSource()}
          >
            {(recommendedBy.source === "press / media") &&
              <RadioButton
                model={`${model}.pressSource`}
                id="recommended-by-private-eye"
                value="private eye"
                label="Private Eye"
                className="press-option"
              />
            }
            {(recommendedBy.source === "press / media") &&
              <RadioButton
                model={`${model}.pressSource`}
                id="recommended-by-the-week"
                value="the week"
                label="The Week"
                className="press-option"
              />
            }
            {(recommendedBy.source === "press / media") &&
              <RadioButton
                model={`${model}.pressSource`}
                id="recommended-by-guardian"
                value="the guardian"
                label="The Guardian"
                className="press-option"
              />
            }
            {(recommendedBy.source === "press / media") &&
              <RadioButton
                model={`${model}.pressSource`}
                id="recommended-by-telegraph"
                value="the telegraph"
                label="The Telegraph"
                className="press-option"
              />
            }
            {(recommendedBy.source === "press / media") &&
              <RadioButton
                model={`${model}.pressSource`}
                id="recommended-by-times"
                value="the times"
                label="The Times"
                className="press-option"
              />
            }
            {(recommendedBy.source === "press / media") &&
              <RadioButton
                model={`${model}.pressSource`}
                id="recommended-by-other-press"
                value="other press"
                label="Other"
                className="press-option"
              >
                {(recommendedBy.pressSource === "other press") &&
                  <Control.text
                    model={`${model}.otherPressSource`}
                    placeholder="Please specify"
                  />
                }
              </RadioButton>
            }
          </RadioButton>
          <RadioButton
            model={`${model}.source`}
            id="recommended-by-social-media"
            value="social media"
            label="Social media"
            onCheckedChange={isChecked => isChecked && this.resetOtherAndPressSource()}
          />
          <RadioButton
            model={`${model}.source`}
            id="recommended-by-word-of-mouth"
            value="word of mouth"
            label="Recommended by someone"
            onCheckedChange={isChecked => isChecked && this.resetOtherAndPressSource()}
          />
          <RadioButton
            model={`${model}.source`}
            id="recommended-by-other"
            value="other"
            label="Other"
          >
            {(recommendedBy.source === "other") &&
              <Control.text
                model={`${model}.otherSource`}
                placeholder="Please specify"
              />
            }
          </RadioButton>
        </div>
      </section>
    );
  }
}
